function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

const titles = {
  site: 'Site',
  tc: 'Traject Controle'
};

const privs = {
  site: 'pr_site_files',
  tc: 'pr_tc_files'
};

const urls = {
  site: '/sites/files',
  tc: '/routecontrols/files'
};

const reportUrls = {
  site: '/sites/reports',
  tc: '/routecontrols/reports'
};

const filterNames = {
  site: 'sitereportfiles',
  tc: 'tcreportfiles'
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  overviewTitle: 'Bestanden',
  detailTitle: 'Bestand',
  deleteTitle: 'dit bestand',
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/sitereportfiles/',
  multiSelect: true,
  sortBy: ['file.name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName(context) {
    return filterNames[getType(context)];
  },
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'str'
  },
  addRecord: false,
  advancedSearchFields(context) {
    return [
      {
        text: titles[getType(context)],
        value: 'site_id',
        type: 'optionList',
        optionListName: 'sites',
        optionListDynamicParams: { devicegroupview_id: 'this.viewId' }
      },
      {
        text: 'Rapport',
        value: 'sitereport_code',
        type: 'text'
      },
      {
        text: 'Type',
        value: 'file_type_id',
        type: 'optionList',
        optionListName: 'filetypes'
      },
      {
        text: 'Toezichter',
        value: 'supervisor_id',
        type: 'optionList',
        optionListName: 'supervisors'
      },
      {
        text: 'Periode van',
        value: 'date_start',
        type: 'date'
      },
      {
        text: 'Periode tot',
        value: 'date_end',
        type: 'date'
      }
    ];
  },
  tableFields(context) {
    return [
      {
        text: 'Naam',
        value: 'file.name',
        link: urls[getType(context)] + '/{id}',
        width: '30%'
      },
      {
        text: titles[getType(context)],
        value: 'site_serial_nr',
        width: '20%'
      },
      {
        text: 'Rapport',
        value: 'sitereport_code',
        link: reportUrls[getType(context)] + '/{sitereport_id}',
        width: '15%'
      },
      {
        text: 'Type',
        value: 'filetype_name',
        width: '10%'
      },
      {
        text: 'Datum',
        value: 'file.timestamp',
        width: '15%',
        filter: 'date'
      }
    ];
  }
};
